import { hcpAPI, nonceHcpAPI, setAuthToken } from 'configs/axios';
import { setAPIServer, setNonceSession, setSession } from 'utils/storage';

const termsEndpoint = '/configurations/termsofuse';

export const NONCE_SRV = 'nonce-server';

export const forgotPassword = (data: { email: string }) => {
  return hcpAPI({ url: '/users/password/forgot', method: 'POST', data });
};

export const resetPassword = (data: {
  new_password: string;
  confirm_password: string;
  token?: string;
}) => {
  return hcpAPI({
    url: '/users/password/reset',
    method: 'POST',
    data,
    config: { headers: {} },
  });
};

export const updatePassword = (data: {
  old_password: string;
  new_password: string;
  confirm_password: string;
}) => {
  return hcpAPI({ url: 'users/password', method: 'PATCH', data });
};

export const updatePersonalDetails = (data: {
  first_name: string;
  last_name: string;
  email: string;
  title: string;
  npi: string;
}) => {
  return hcpAPI({ url: 'users', method: 'PATCH', data });
};

export const fetchUser = (signal?: AbortSignal | undefined) => {
  return hcpAPI({ url: '/users', method: 'GET', config: { signal } });
};

export const loginUser = (values: { service: string; email: string; password: string }) => {
  return hcpAPI({
    url: '/users/login/neo',
    method: 'POST',
    data: values,
    config: { headers: {} },
  });
};

export const fetchTermsofUse = (
  language: string,
  region: string,
  signal?: AbortSignal | undefined
) => {
  const type = 'nightowl-portal';
  const params = {
    language,
    region,
    type,
  };
  return hcpAPI({ url: termsEndpoint, method: 'GET', config: { params, signal } });
};

export const postTermsOfUse = (values: { version_id: string; type: string }, authType?: string) => {
  return authType === 'nonce'
    ? nonceHcpAPI({
        url: termsEndpoint,
        method: 'POST',
        data: values,
      })
    : hcpAPI({ url: termsEndpoint, method: 'POST', data: values });
};

export function externalLogin(authToken: string, service: string | null, region: string | '') {
  setAuthToken(authToken, service);
  localStorage.setItem('session', JSON.stringify({ token: authToken, service }));
  setSession(authToken, service);
  setAPIServer(region);
  return {
    type: 'EXTERNAL LOGIN',
  };
}

export function nonceLogin(
  nonce: string | null,
  signingKey: string,
  service: string | null,
  region: string | ''
) {
  setNonceSession(nonce, signingKey, service);
  localStorage.setItem('session', JSON.stringify({ token: nonce, signingKey, service }));
  localStorage.setItem(NONCE_SRV, region);
  return {
    type: 'Nonce login',
  };
}
